



































import Vue from 'vue';
import { EventBus, graph } from './main';

//import requestform from '@/components/requestform.vue';
import grapheditor from '@/components/graphEditor.vue';
import metadataviewer from '@/components/metadataViewer.vue';
// import graphbuilder from '@/components/graphBuilder.vue';
import graphviewer from '@/components/graphViewer.vue';
// @ is an alias to /src

// <graphviewer v-if="graph" v-bind:graph="graph" />


export default Vue.extend({
  name: 'home',
  components: {
    // requestform,
    grapheditor,
    metadataviewer,
    graphviewer,
  },
  data(){ return {
    mainpanel: 'editor',
    graph: null,
    graphspec: null,
    drawSecondary: true,
    selectednode: undefined,
    nodelist: graph.state.nodelist,
  }},
  created (){
    EventBus.$on('newgraphrequest', (graphspec) => {
      this.state = 'building';
      this.graphspec = graphspec;
    });
    EventBus.$on('graphfinished', (graph) => {
      this.state = 'view';
      this.graph = graph;
    });
    EventBus.$on('showmetadata', (doi) => {
      this.selectednode = doi;
    });
    EventBus.$on('closemetadata', () => {
      this.selectednode = undefined;
    });

    EventBus.$on('storageUpdate', () => {
      this.$forceUpdate();
    });
  },
});
